import React, { useEffect, useRef } from 'react';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

export const BookingMap = ({ lat, lng }) => {
  const containerRef = useRef(null);
  const mapRef = useRef(null);
  const markerRef = useRef(null);

  useEffect(() => {
    if (!containerRef.current || mapRef.current) return;
    const map = L.map(containerRef.current, {
      zoomControl: false,
      attributionControl: false,
      dragging: false,
      scrollWheelZoom: false,
      doubleClickZoom: false,
      touchZoom: false,
    }).setView([43.6516, -79.6032], 8);
    L.tileLayer('https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png', { maxZoom: 19 }).addTo(map);
    mapRef.current = map;
    return () => { map.remove(); mapRef.current = null; };
  }, []);

  useEffect(() => {
    const map = mapRef.current;
    if (!map || lat == null || lng == null) return;
    if (markerRef.current) markerRef.current.remove();
    const icon = L.divIcon({
      className: '',
      html: '<div style="width:18px;height:18px;background:#D4AF37;border:3px solid #0f0f10;border-radius:50%;box-shadow:0 0 14px #D4AF37"></div>',
      iconSize: [18, 18],
      iconAnchor: [9, 9],
    });
    markerRef.current = L.marker([lat, lng], { icon }).addTo(map);
    map.flyTo([lat, lng], 11, { duration: 1.5 });
  }, [lat, lng]);

  return <div ref={containerRef} className="w-full h-full" data-testid="booking-map" />;
};
